module.exports = __webpack_public_path__ + "static/media/star-ball_08.fd2f3abf.png";